import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { styled } from '@airwallex/theme';
import Main from './Main';
import Error from './Error';
import { logPerformanceMetrics } from '@/utils/performance';
import { getCorpsiteUrl } from '@/utils/environment';
export const Wrapper = styled.div`
  p {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0;
  }
`;

const ExternalBillingHostedInvoiceRouter = (): JSX.Element => {
  useEffect(() => {
    logPerformanceMetrics(['/billing/payer-web-api', getCorpsiteUrl()]);
  }, []);

  return (
    <Wrapper>
      <BrowserRouter>
        <Switch>
          <Route path="/pay" component={() => <Main />} exact />
          <Route path="/pay/error" component={() => <Error />} exact />
        </Switch>
      </BrowserRouter>
    </Wrapper>
  );
};

export default ExternalBillingHostedInvoiceRouter;
